module.exports = __webpack_public_path__ + "static/mysa-plus-cover-84b40905578f025308bce9d4a7ef0dc5.mp4";